import { commonUseCloseBtnSquared } from '../../common/common-close-btn';
import { commonArrowBtn } from '../../common/common-use-arrow-btn';
import { commonUseBorderLayer } from '../../common/common-use-border-layer';
import { builder } from '../../../../../../common/js/configs';
import { units } from '../../../../../../common/js/configs/constants';

export const formatConfigUnmarshaller = {
  ...commonUseCloseBtnSquared,
  ...commonArrowBtn,
  ...commonUseBorderLayer,
  creative: builder.holder({
    creativeRatio: builder.number('creative_ratio', {
      l:'',
      description: `Ratio of the Asset<br>
Define if the creative orientation is portrait or landscape<br>
Mandatory for Thumbnail Ad delivery<br>
Default values are 1.78 for landscape and 0.56 for portrait for a 16:9 Asset`,
      unit: units.aspectRatio
    })
  }),
  backgroundTransparent: builder.boolean('background_transparent', {
    defaultValue: false
  })
};
